import React, { forwardRef, useRef } from "react";
import { useLoaderData } from "react-router-dom";
import { Printer } from "iconsax-react";
import { useReactToPrint } from "react-to-print";
import { getToken } from "../../../../utils/token";
import instance, { url } from "../../../../axios/instance";

export const invoiceItemLoader = async ({ params }) => {
  const token = getToken();
  const res = await instance.post(
    "/doctor/invoice/single",
    {
      invoiceId: params.id,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

export const InvoiceItemPage = () => {
  const invoice = useLoaderData();
  const invoiceRef = useRef(null);
  if (!invoice) return <div className="px-7 py-5 bg-bg">Invoice not found</div>;

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
  });
  return (
    <div className="w-full bg-bg">
      <div ref={invoiceRef} className="px-7 py-5 bg-bg">
        <div className="flex justify-between">
          <div className="text-2xl font-bold">Invoice (#{invoice.id})</div>
          <div>
            <strong className="font-semibold">Received Date:</strong>
            <span className="ml-2">
              {new Date(invoice.created_at)
                .toLocaleDateString()
                .split("/")
                .reverse()
                .join("-")}
            </span>
          </div>
        </div>
        <InvoiceItem invoice={invoice} />
      </div>
      <div className="mt-5 px-7">
        <button
          className="text-xs md:w-full xl:w-[150px] h-[40px] flex items-center justify-center bg-primary text-white rounded-md py-2 px-2 hover:opacity-80 duration-200 disabled:cursor-not-allowed disabled:opacity-70 cursor-pointer"
          onClick={handlePrint}
        >
          <Printer size="22" color="white" className="mr-1.5" />
          Print Slip
        </button>
      </div>
    </div>
  );
};

const InvoiceItem = ({ invoice }) => {
  return (
    <div className="border bg-white rounded-md overflow-x-scroll scrollbar-hide mt-4">
      <div className="flex justify-center p-2 items-center border-b">
        <img
          src={`${url}${invoice.pharmacy.logo_path}`}
          alt="pharmacy logo"
          className="h-20"
        />
      </div>
      <div className="max-w-[70%] mx-auto flex justify-between pt-8 mb-8">
        <div>
          <span className="block mb-1.5">Sender Details</span>
          <div className="my-1.5 text-sm">
            <strong>Name: </strong>
            {invoice.pharmacy.pharmacy_name}
          </div>
          <div className="my-1.5 text-sm">
            <strong>Email: </strong>
            {invoice.pharmacy.email}
          </div>
          <div className="my-1.5 text-sm">
            <strong>Phone: </strong>
            {invoice.pharmacy.phone}
          </div>
          <div className="my-1.5 text-sm">
            <strong>Address: </strong>
            {invoice.pharmacy.address}
          </div>
        </div>
        <div>
          <span className="block mb-1.5">Receiver Details</span>
          <div className="my-1.5 text-sm">
            <strong>Name: </strong>
            {invoice.facility.name}
          </div>
          <div className="my-1.5 text-sm">
            <strong>Email: </strong>
            {invoice.facility.email}
          </div>
          <div className="my-1.5 text-sm">
            <strong>Phone: </strong>
            {invoice.facility.office_phone}
          </div>
          <div className="my-1.5 text-sm">
            <strong>Address: </strong>
            {invoice.facility.address1}
          </div>
        </div>
      </div>
      <table className="w-full relative whitespace-nowrap">
        <thead>
          <tr className="uppercase h-14 font-bold bg-[#f1f1f1] text-gray-700 text-[12px]">
            <td className="px-6 py-4">#</td>
            <td className="px-6 py-4">Order ID</td>
            <td className="px-6 py-4">Medications</td>
            <td className="px-6 py-4">Total</td>
            <td className="px-6 py-4">Completed Order</td>
          </tr>
        </thead>
        <tbody>
          {invoice.orders.length < 1 ? (
            <tr>
              <td className="px-6 py-4" colSpan={6}>
                No order
              </td>
            </tr>
          ) : (
            invoice.orders.map((order, index) => (
              <tr key={index} className="h-14 text-[14px] border-b">
                <td className="px-6 py-4">{index + 1}</td>
                <td className="px-6 py-4">{order.id}</td>
                <td className="px-6 py-4">
                  {JSON.parse(order.medication).length}
                </td>
                <td className="px-6 py-4">${order.total}</td>
                <td className="px-6 py-4">
                  {new Date(order.completed_at).toLocaleString()}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="flex justify-end mb-5">
        <div className="mt-4 w-[25%] flex justify-between pr-7">
          <strong className="font-semibold">Total:</strong>
          <span className="ml-2">${invoice.total}</span>
        </div>
      </div>
    </div>
  );
};
